// packages
import { Helmet } from "react-helmet-async";

// components (shared)
import JewelryUI from "../shared/components/JewelryUI";

// components (template)
// import Header from "../components/Header";
// import ImageBanner from "../components/ImageBanner";
import StandardContainer from "../components/StandardContainer";

// data
// import { categories } from "../data/categories";

export default function Jewelries() {
  return (
    <>
      <Helmet>
        <title>Jewelry - Ninacci</title>
        <meta
          name="description"
          content="Discover our exquisite collection of fine jewelry crafted with exceptional artistry and masterful craftsmanship."
        />
      </Helmet>
      {/* <Header title="Jewelry Search" /> */}
      {/* <ImageBanner image={categories.jewelry.banner} /> */}
      <div className="font-cartier-sans my-2 font-semibold text-black md:my-4">
        <StandardContainer content={<JewelryUI />} />
      </div>
    </>
  );
}
